import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 手动录入
 */
const entering = {

  /**
   * 写入统计量
   */
  setQuantitiesHour (measureId, pointCode, pointNumber, segmentId, time, values, froce) {
    return axios.post(base.entering.setQuantitiesHour, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber, segmentId, time, values, froce }))
  },
  /**
   * 写入统计量
   */
  setQuantitiesDay (measureId, pointCode, pointNumber, segmentId, time, values, froce) {
    return axios.post(base.entering.setQuantitiesDay, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber, segmentId, time, values, froce }))
  },
  /**
   * 写入统计量
   */
  setQuantitiesMonth ( measureId, pointCode, pointNumber, segmentId, time, values, froce) {
    return axios.post(base.entering.setQuantitiesMonth, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber, segmentId, time, values, froce }))
  },
  /**
   * 写入统计量
   */
  setQuantitiesYear (measureId, pointCode, pointNumber, data, froce) {
    return axios.post(base.entering.setQuantitiesYear, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber, data, froce }))
  },
  /**
   * 写入累计量（表读数）
   */
  setMeasuringRawValueForCount (measureId, pointCode, pointNumber, data, froce) {
    return axios.post(base.entering.setMeasuringRawValueForCount, utils.postParamsArrayToJsonString({ measureId, pointCode, pointNumber, data, froce }))
  },
}

export default entering